module.exports = __webpack_public_path__ + "img/11.decd1936.jpg";